import { DEFAULT_ORGANIZATIONAL_UNIT_ID } from '../../consts/DataConsts';

export const getCleanOrgUnitIds = (orgUnitIds?: string[]): string[] | undefined => {
    if (!orgUnitIds) {
        return;
    }

    const clearIds: string[] = orgUnitIds.filter(id => id !== DEFAULT_ORGANIZATIONAL_UNIT_ID);
    return (clearIds.length > 0) ? clearIds : undefined;
};